//  ============== importing  banner video  ==================
import bannerVideo from 'assets/videos/bannerVideo.mp4';
//  ============== banner image for as a placeholder until our video load ===================
import posterImg from 'assets/images/others/videoPoster.webp';

const VideoBanner = () => {
    // ============
    const scrollTo_Section = (sec_id) => {
        let element = document.getElementById(sec_id);
        if (element) {
            const y = element.getBoundingClientRect().top + window.pageYOffset - 100;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };
    return (
        <section id="video_banner">
            {/*  ===================  Here is the banner video ================= */}
            <video src={bannerVideo}  autoPlay loop muted  poster={posterImg}>
                <source src={bannerVideo}/>
            </video>
            <div className="container">
                <div className="text_center banner_content_wrapper row column ">
                    <h2 data-aos="fade-up">A free-to-use decentralized <br/> live streaming platform</h2>
                    <p data-aos="fade-up">A custom utility token that is used to engage with content creators</p>
                    <div className="row" data-aos="fade-up">
                        {/*  */}
                    <button  className="cs_btn" onClick={()=>scrollTo_Section('features')}>App Features</button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VideoBanner;
